import axios from '../../_utils/axios';
import store, { DELETE_LOADER, persistor } from '../../../store';

// ----------------------------------------------------------------------

const getGeneral = (id: string) => {
  return axios.get(`iot-devices/${id}/general`);
};

const getPower = (id: string) => {
  return axios.get(`iot-devices/${id}/power`);
};

const getAction = (id: string) => {
  return axios.get(`iot-devices/${id}/action`);
};

// ----------------------------------------------------------------------

const getDeviceInfo = async (setData: React.Dispatch<any>, id: string) => {
  return await Promise.all([getGeneral(id), getPower(id), getAction(id)])
    .then((response) => {
      return setData({
        general: response[0].data.data,
        power: {...response[1].data.data, enabled: response[0].data.data.enabled},
        action: {...response[2].data.data, enabled: response[0].data.data.enabled},
      });
    })
    .catch((error) => {
      const code = error.response.data.code;
      
      if ( error.code === 'ERR_BAD_RESPONSE' ) {
        persistor.purge();
        return window.location.href = '/alert';
      } else if ( code === 'ERR-001' || code === 'ERR-REISSUE' ) {
        persistor.purge();
        return window.location.href = '/login';
      } else {
        return Promise.reject(error);
      }
    })
    .finally(() => store.dispatch( DELETE_LOADER() ));
};

export default getDeviceInfo;